import Link from 'next/link';
import { PropsWithChildren } from 'react';
import Logo from '@/components/common/logo';
import Spinner from '@/components/ui/spinner';
export default function ResetConfirmation({
  children
}: PropsWithChildren) {
  return <div className="flex flex-1 flex-col h-screen items-center justify-center gap-10" data-sentry-component="ResetConfirmation" data-sentry-source-file="confirmation-info.tsx">
      <Link className="mx-auto w-fit" href={'/'} data-sentry-element="Link" data-sentry-source-file="confirmation-info.tsx">
        <Logo data-sentry-element="Logo" data-sentry-source-file="confirmation-info.tsx" />
      </Link>
      <p className="w-3/4 text-center font-medium">{children}</p>
      <Spinner color="black" data-sentry-element="Spinner" data-sentry-source-file="confirmation-info.tsx" />
      <p className="text-sm -mt-8">redirecting home...</p>
    </div>;
}